import AppConstants from '../../AppConstants';

// this file is copied from e2e project. ensure that is is same as e2e project always
export function initializeIntercom(user) {
  let { email, userKey, displayName } = user || {};
  if (!(email && userKey && displayName)) {
    return;
  }

  try {
    window.Intercom('boot', {
      email,
      app_id: AppConstants.INTERCOM_ID,
      name: displayName,
      user_id: userKey
    });
  } catch (error) {
    // TODO: Log Error
  }
}

export function hideIntercomMessenger() {
  try {
    window.Intercom('hide');
  } catch (error) {
    // TODO: Log Error
  }
}

export function showIntercomMessenger() {
  try {
    window.Intercom('show');
  } catch (error) {
    // TODO: Log Error
  }
}

export function shutdownIntercomMessenger() {
  try {
    window.Intercom('shutdown');
  } catch (error) {
    // TODO: Log Error
  }
}



// WEBPACK FOOTER //
// ./src/Telemetry/Intercom/intercom.js